import type { AuthConfig } from '@tmapy/beetlejuice-utils';
import { fetchJSON } from '@tmapy/beetlejuice-utils';
import { getAbsoluteUrl } from '@tmapy/beetlejuice-utils';

import { SUCCESS_ALERT_VISIBLE, SET_CONFIG_TO_STORE } from '../constants';
import type { DmxConfig } from '../types';

export type AppActionTypes =
  | ReturnType<typeof setConfigToStore>
  | ReturnType<typeof changeSubmitSuccessAlertVisibility>
  | ReturnType<typeof changeDeleteSuccessAlertVisibility>;

export const loadConfig = async () => {
  const pathBase = new URL(process.env.PUBLIC_URL || '/', window.location.href).toString();
  const dmxConfig = (await fetchJSON(`${pathBase}dmx.json`)) as DmxConfig;

  const vydej =
    dmxConfig.vydej?.areaTypes || dmxConfig.vydej
      ? { areaTypes: dmxConfig.vydej?.areaTypes, ...dmxConfig.vydej }
      : undefined;

  const server = getAbsoluteUrl(globalThis.CONFIG?.backends?.dmx)?.origin;
  if (server === undefined) {
    throw new Error('The configuration is without backend endpoint.');
  }

  return { ...dmxConfig, vydej, auth: globalThis.CONFIG?.auth, server };
};

export const setConfigToStore = (config: DmxConfig & { auth?: AuthConfig; server: string }) =>
  ({
    type: SET_CONFIG_TO_STORE,
    config,
  }) as const;

export const changeSubmitSuccessAlertVisibility = (value: boolean) =>
  ({
    type: SUCCESS_ALERT_VISIBLE.SUBMIT,
    value,
  }) as const;

export const changeDeleteSuccessAlertVisibility = (value: boolean) =>
  ({
    type: SUCCESS_ALERT_VISIBLE.DELETE,
    value,
  }) as const;
